import { computed } from 'vue';
import type { Permission } from '@/api/permissions';
import { useUser } from './useUser';

export function usePermissions() {
  const { user } = useUser();

  const hasPermission = computed(() => (resource: string, action: string) => user?.value?.role?.permissions?.some(
    (permission: Permission) => permission.resource === resource && permission.action === action,
  ) ?? false);

  return {
    hasPermission,
  };
}
